import { render, staticRenderFns } from "./EventDeletePopup.vue?vue&type=template&id=3961aabe"
import script from "./EventDeletePopup.vue?vue&type=script&lang=js"
export * from "./EventDeletePopup.vue?vue&type=script&lang=js"
import style0 from "./EventDeletePopup.vue?vue&type=style&index=0&id=3961aabe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports